import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "columns is-centered is-hidden-mobile" }
const _hoisted_3 = { class: "column is-5" }
const _hoisted_4 = { class: "steps" }
const _hoisted_5 = { class: "step-item is-completed is-info" }
const _hoisted_6 = { class: "step-marker" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Search")
], -1)
const _hoisted_9 = { class: "step-item is-info is-completed" }
const _hoisted_10 = { class: "step-marker" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Citations")
], -1)
const _hoisted_13 = { class: "step-item is-info is-active" }
const _hoisted_14 = { class: "step-marker" }
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Pay Bill")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 is-spaced" }, "Pay Bill")
  ])
], -1)
const _hoisted_18 = { class: "columns" }
const _hoisted_19 = { class: "column" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "" }, "How would you like to pay this bill?")
  ])
], -1)
const _hoisted_21 = { class: "columns" }
const _hoisted_22 = { class: "column is-8" }
const _hoisted_23 = { class: "is-grey-background" }
const _hoisted_24 = { class: "columns" }
const _hoisted_25 = { class: "column" }
const _hoisted_26 = { class: "column has-vertical-bar" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("p", null, "No account? No Problem")
  ])
], -1)
const _hoisted_28 = { class: "columns" }
const _hoisted_29 = { class: "column" }
const _hoisted_30 = { class: "column is-3" }
const _hoisted_31 = { class: "box" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 is-spaced" }, "Total")
  ])
], -1)
const _hoisted_33 = { class: "columns" }
const _hoisted_34 = { class: "column" }
const _hoisted_35 = { class: "level" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "level-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Citation Total")
  ])
], -1)
const _hoisted_37 = { class: "level-right" }
const _hoisted_38 = { class: "level-item" }
const _hoisted_39 = { class: "columns" }
const _hoisted_40 = { class: "column" }
const _hoisted_41 = { class: "level" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "level-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Amount Credited")
  ])
], -1)
const _hoisted_43 = { class: "level-right" }
const _hoisted_44 = { class: "level-item" }
const _hoisted_45 = { class: "columns" }
const _hoisted_46 = { class: "column" }
const _hoisted_47 = { class: "level" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "level-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Remaining Balance")
  ])
], -1)
const _hoisted_49 = { class: "level-right" }
const _hoisted_50 = { class: "level-item" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_52 = { class: "columns" }
const _hoisted_53 = { class: "column" }
const _hoisted_54 = { class: "control" }
const _hoisted_55 = { class: "title is-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_page = _resolveComponent("login-page")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_field = _resolveComponent("o-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_o_icon, { icon: "check" })
              ])
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_o_icon, { icon: "check" })
              ])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_o_icon, { icon: "circle-small" })
              ])
            ]),
            _hoisted_16
          ])
        ])
      ])
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_router_link, { to: "/results" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_icon, { icon: "arrow-left" }),
            _createTextVNode(" Back")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_login_page, { partial: "" })
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_o_button, {
                    variant: "info",
                    outlined: "",
                    class: "has-background-white",
                    onClick: _ctx.checkoutAsGuest
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Continue as guest")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.results.Overview.TotalAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.results.Overview.AmountPaid.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.results.Overview.FullPaymentAmountDue.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                ])
              ])
            ])
          ]),
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_o_field, {
                label: "Amount To Pay",
                class: "has-text-right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("h6", _hoisted_55, _toDisplayString(_ctx.results.Overview.AmountToPay.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}